import React from "react";

import { EventBasicProfile } from "./eventManagerBasicProfile";
import { EventManager } from "../eventManage";
import { Link} from "react-router-dom";
import { useLocation } from "react-router-dom";
export function EventEditProfile() {
   const location = useLocation();
  const userId = location.state?.id;
  console.log("userId", userId);
  return (
    <div className="matchMainContainer">
      <div className="matchEdit-subcontainer">
        <Link to="/event-manager">
         <div
          className="bi bi-arrow-left"
         
        ></div>
        </Link>
       
        <div className="matchBasic-menu">
          <div>Basic Information</div>
        </div>
      </div>
      <div>
        <EventBasicProfile userId={userId} />
      </div>
    </div>
  );
}
